import { TResponseType } from '@@types/base';
import apis from '@apis/index';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const useCountry = (
  options: UseMutationOptions<
    AxiosResponse<TResponseType>,
    unknown,
    { country: string }
  >,
) => useMutation(apis.setting.updateCountry, options);
